import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { EventApi } from 'api';
import type { Event } from 'api/methods/EventApi';

/**
 * [Event] Query key 생성
 * --
 */
export const eventQueryKeys = createQueryKeys('event', {
  getEvent: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getEvents: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Event] 공지사항 전체 조회
 * --
 */
export const useGetEvents = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: eventQueryKeys.getEvents(params).queryKey,
    queryFn: () => EventApi.getEvents(params),
    ...options,
  });
  return data;
};

/**
 * [Event] 공지사항 상세 조회
 * --
 */
export const useGetEvent = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: eventQueryKeys.getEvent(idx, params).queryKey,
    queryFn: () => EventApi.getEvent(idx, params),
    ...options,
  });

  return data;
};

/**
 * [Event] 공지사항 생성
 * --
 */
export const useCreateEvent = (body: Event) => {
  const { mutateAsync: createEvent, ...result } = useMutation({
    mutationFn: (variables: Event) => EventApi.createEvent(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createEvent, ...result };
};

/**
 * [Event] 공지사항 수정
 * --
 */
export const useUpdateEvent = (body: Event) => {
  const { mutateAsync: updateEvent, ...result } = useMutation({
    mutationFn: (variables: Event) => EventApi.updateEvent(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateEvent, ...result };
};

/**
 * [Event] 공지사항 삭제
 * --
 */
export const useDeleteEvent = (idx: number) => {
  const { mutateAsync: deleteEvent, ...result } = useMutation({
    mutationFn: (variables: number) => EventApi.deleteEvent(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteEvent, ...result };
};

/**
 * [Event] 배너 생성
 * --
 */
export const useUpsertEvent = () => {
  const { mutateAsync: upsertEvent, ...result } = useMutation({
    mutationFn: (variables: Event[]) => EventApi.upsertEvent(variables),
  });

  return { upsertEvent, ...result };
};
